import { ReactNode, useEffect, useLayoutEffect, useState } from 'react';
import { setAnalyticsConsent } from '@/lib/analytics';
import { ConsentContext, getIubendaConsent } from './ConsentContext.ts';

export function ConsentProvider({ children }: { children: ReactNode }) {
  const initialConsent = getIubendaConsent();
  const [analyticsAllowed, setAnalyticsAllowed] = useState<boolean | null>(initialConsent);

  useLayoutEffect(() => {
    setAnalyticsConsent(analyticsAllowed === true);
  }, [analyticsAllowed]);

  useEffect(() => {
    const updateConsent = () => {
      setAnalyticsAllowed(current => {
        const next = getIubendaConsent();
        return next === null ? current : next;
      });
    };

    const events = [
      'iubenda:preference-expressed',
      'iubenda:consent-given',
      'iubenda:consent-rejected',
    ];
    events.forEach(event => window.addEventListener(event, updateConsent));

    return () => {
      events.forEach(event => window.removeEventListener(event, updateConsent));
    };
  }, []);

  return <ConsentContext.Provider value={{ analyticsAllowed }}>{children}</ConsentContext.Provider>;
}
